import React from 'react';

import { IconWrapper } from 'components/Icon';

export const DragHandle = () => (
  <IconWrapper
    icon="bars3"
    sx={({ palette }) => ({
      svg: { width: 20, height: 20, stroke: palette.grey[500], color: palette.grey[500] },
    })}
  />
);
